import React from 'react'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import UserLogs from "../component/User/UserLogs/UserLogs.jsx"
const UserLogsPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  return (
    <>
    <Header/>
    <UserLogs/>
    <Footer/>
    </>
  )
}

export default UserLogsPage